export const normalizeUnitCasing = (s) =>
  String(s ?? '')
    .replace(/\bMBPS\b/g, 'Mbps')
    .replace(/\bGBPS\b/g, 'Gbps')
    .replace(/\bKBPS\b/g, 'Kbps');

export const ensureTrailingPeriod = (s) =>
  `${String(s ?? '').trim().replace(/\.+$/, '')}.`;
